import { RootState } from '@/store/main';

export const selectThemePacks = (state: RootState) => state.templates.themePacks;
export const selectTemplates = (state: RootState) => state.templates.templates;
export const selectLoadingTemplatesAndThemes = (state: RootState) => state.templates.loadingTemplatesAndThemes;
export const selectTotalTemplates = (state: RootState) => state.templates.totalTemplates;
export const selectTemplateFilters = (state: RootState) => state.templates.templateFilters;
export const selectUserTemplateFavorites = (state: RootState) => state.templates.userFavorites;
export const selectRefetchTemplatesCounter = (state: RootState) => state.templates.refetchTemplatesCounter;
export const selectTemplatesListPage = (state: RootState) => state.templates.templatesListPage;
export const selectRenderLoadingList = (state: RootState) => state.templates.renderLoadingList;
export const selectLoadingTemplateFilters = (state: RootState) => state.templates.loadingTemplateFilters;
export const selectFontPacks = (state: RootState) => state.templates.fontPacks;
export const selectLoadingFontPacks = (state: RootState) => state.templates.loadingFontPacks;
